import { render, staticRenderFns } from "./TodoInput.vue?vue&type=template&id=60d5fd15&scoped=true&"
import script from "./TodoInput.vue?vue&type=script&lang=js&"
export * from "./TodoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5fd15",
  null
  
)

export default component.exports